var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 3,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.645 1.5H1.355",
    stroke: "#492A2A",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
export default __webpack_public_path__ + "0a69539fe0d5896c9b0395a0ad3301f6.svg";
export { SvgMinus as ReactComponent };